import { NgModule } from '@angular/core';
import { CustomLayoutModule } from '../../custom-layout/custom-layout.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { ExpirationDateComponent } from './expiration-date.component';
import { ExpirationDateRoutingModule } from './expiration-date-routing.module';
import { MaterialModule } from 'src/app/shared/modules/materia.module';
import { AssetUrlModule } from 'src/pipes/asset-url.module';
import { SharedComponentsModule } from 'src/app/shared/ui/shared-components.module';


@NgModule({
  declarations: [ExpirationDateComponent],
  imports: [
    ExpirationDateRoutingModule,
    CustomLayoutModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule,
    AssetUrlModule,
    SharedComponentsModule
  ],
  providers: [
    CustomizationService
  ],
})
export class ExpirationDateModule { }
